export const PROPERTY_TYPE_MULTI_SELECT = 'multi_select';
export const PROPERTY_TYPE_SELECT = 'select';
export const PROPERTY_TYPE_STATUS = 'status';
export const PROPERTY_TYPE_EMAIL = 'email';
export const PROPERTY_TYPE_NUMBER = 'number';
export const PROPERTY_TYPE_RICH_TEXT = 'rich_text';
export const PROPERTY_TYPE_TITLE = 'title';
export const PROPERTY_TYPE_URL = 'url';
export const PROPERTY_TYPE_CHECKBOX = 'checkbox';
export const PROPERTY_TYPE_PHONE_NUMBER = 'phone_number';
export const PROPERTY_TYPE_DATE = 'date';
